/**
 * Boutons d'action des sections `product-story` sur une page produit.
 *
 * Même principe que la barre d'achat collante : le bouton ne poste rien lui-même, il
 * clique le vrai bouton d'ajout (`.product-form__submit`). Toute la logique d'achat —
 * variante choisie, quantité, widget de bundles, ouverture du tiroir, gestion d'erreur —
 * reste celle du formulaire produit, et ces boutons ne peuvent pas s'en désynchroniser.
 *
 * Ils recopient aussi l'état désactivé du vrai bouton : un produit en rupture ne doit pas
 * afficher en bas de page un bouton d'achat qui semble actif mais ne fait rien.
 */
(() => {
  // Une page peut contenir plusieurs sections `product-story` à bouton d'action, et donc
  // plusieurs balises <script> vers ce fichier. Le navigateur ne le télécharge qu'une
  // fois mais exécute chaque balise : sans ce garde, l'écouteur délégué serait posé en
  // double et un clic ajouterait deux fois au panier.
  if (window.__productStoryCta) return;
  window.__productStoryCta = true;

  const TRIGGERS = '[data-product-story-action]';

  const realButton = () => document.querySelector('.product-form__submit');

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(TRIGGERS);
    if (!trigger) return;

    const target = realButton();
    if (!target) return;

    if (trigger.dataset.productStoryAction === 'add_to_cart') {
      target.click();
      return;
    }

    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    // `focus` sans `preventScroll` annulerait le défilement fluide qu'on vient de lancer.
    target.focus({ preventScroll: true });
  });

  function syncDisabled() {
    const target = realButton();
    if (!target) return;

    const off = target.disabled || target.getAttribute('aria-disabled') === 'true';
    document.querySelectorAll(TRIGGERS).forEach((trigger) => {
      // Seul l'ajout au panier devient impossible ; défiler vers le formulaire reste
      // utile même en rupture, ne serait-ce que pour lire le message d'indisponibilité.
      if (trigger.dataset.productStoryAction === 'add_to_cart') trigger.disabled = off;
    });
  }

  syncDisabled();

  const target = realButton();
  if (target) {
    new MutationObserver(syncDisabled).observe(target, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
  }
})();
